const Events = {
  TOGGLE_PROFILE_BOX: 'TOGGLE_PROFILE_BOX',
  CLOSE_PROFILE_BOX: 'CLOSE_PROFILE_BOX',
  SHOW_PROFILE_BOX: 'SHOW_PROFILE_BOX',
  SHOW_MODAL_TREINAMENTOS: 'SHOW_MODAL_TREINAMENTOS',
  HIDE_MODAL_TREINAMENTOS: 'HIDE_MODAL_TREINAMENTOS',
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  LOGOUT: 'LOGOUT',
  SHOW_ERROR: 'SHOW_ERROR',
  SHOW_SUCCESS: 'SHOW_SUCCESS',

  SHOW_HEADER: 'SHOW_HEADER',
  HIDE_HEADER: 'HIDE_HEADER',
  SHOW_FOOTER: 'SHOW_FOOTER',
  HIDE_FOOTER: 'HIDE_FOOTER',
  HEADER_INTERN: 'HEADER_INTERN',
  HEADER_HOME: 'HEADER_HOME',

  SHOW_MENU: 'SHOW_MENU',
  HIDE_MENU: 'HIDE_MENU',
  TOGGLE_MENU: 'TOGGLE_MENU',
  MENU_INTERN: 'MENU_INTERN',
  MENU_HOME: 'MENU_HOME',
  LOGO_INTERN: 'LOGO_INTERN',
  LOGO_HOME: 'LOGO_HOME',
  SUCCESS_FORM: 'SUCCESS_FORM',
  GLOBAL_TRANSITION: 'GLOBAL_TRANSITION',
  CHECK_REGULAMENTO_PRECADASTRO: 'CHECK_REGULAMENTO_PRECADASTRO',
  SAC_ROUTE_CHANGE: 'SAC_ROUTE_CHANGE',
};

export { Events };
